import * as React                  from 'react';
import * as cx                     from 'classnames';
import Linkify                     from 'react-linkify';
import moment                      from 'moment-timezone';
import { getTimeZone }             from '../../helpers/timeUtils';

// components
import {
    MessageStatusText,
    StatusMessages,
    MessageStatusIcon,
    StatusIcons
}                                  from './MessageStatus';
import {
    TimestampSeparator,
    TimeStamp
}                                  from './Timestamp';

// types
import { MessageComponentProps }   from './MessageTypes';
import {
    MessageDeliveryStatuses,
    MessageDeliveryStatusType
}                                  from '../../types';
import { MessageErrorState }       from '../MessagesFeed/MessagesFeedTypes';

const ALLOW_RETRY_HOURS = 2;

// FIXME: this failed state is a hack that corresponds with the timeout because we don't get proper errors back from commcontroller
// in the future we can get rid of this status entirely and just rely on the error status
const getMessage = (status: MessageDeliveryStatusType, retryEnabled: boolean, messageFailed?: boolean, error?: MessageErrorState) => {
    if (retryEnabled) {
        return StatusMessages[MessageDeliveryStatuses.RETRY].message;
    } else if ((messageFailed || status === MessageDeliveryStatuses.ERROR) && error) {
        return error.reason;
    } else if (messageFailed && status !== MessageDeliveryStatuses.ERROR) {
        return StatusMessages[MessageDeliveryStatuses.FAILED].message;
    } else {
        return StatusMessages[status].message;
    }
};

const MessageComponent: React.StatelessComponent<MessageComponentProps> = ({ index, message, messageFailed, translate, error, isLatestMessage, retrySendingMessage }) => {
    const isFailedOrCurrentMessage = (message.currentSession && isLatestMessage) || messageFailed || message.delivery_status === MessageDeliveryStatuses.ERROR;
    const isDnc = message.delivery_status === MessageDeliveryStatuses.DNC;
    const hoursPassed = moment.utc().diff(moment.utc(message.date_added).local().tz(getTimeZone()), 'hours');
    const retryEnabled = (isLatestMessage && message.delivery_status === MessageDeliveryStatuses.ERROR && hoursPassed >= ALLOW_RETRY_HOURS);
    return (
        <div>
        { !isDnc &&
            <div className={cx('messageFeed__messageContainer', { messageFeed__templateContainer : Boolean(message.message_template_id) || Boolean(message.template)})}>
                {
                    index !== 0 && (message.message_template_id || message.templateId) && // according to Message type, can be either camel or snake case?
                    <TimestampSeparator dateAdded={message.date_added} />
                }
                <div className={cx('messagesFeed__event', message.action, { [MessageDeliveryStatuses.ERROR]: messageFailed || message.delivery_status === MessageDeliveryStatuses.ERROR })}>
                    <div className="messagesFeed__message" onClick={retryEnabled ? retrySendingMessage : null}>
                        <div className={cx('messagesFeed__body', { [MessageDeliveryStatuses.ERROR]: messageFailed || message.delivery_status === MessageDeliveryStatuses.ERROR })}>
                            {
                                isFailedOrCurrentMessage &&
                                <MessageStatusIcon {...(messageFailed ? StatusIcons[MessageDeliveryStatuses.ERROR] : StatusIcons[message.delivery_status])} />
                            }
                            <Linkify properties={{ target: '_blank' }}>
                                {message.content}
                            </Linkify>
                        </div>
                    </div>
                    <TimeStamp message={message} />
                    {
                        isFailedOrCurrentMessage &&
                        <MessageStatusText
                            translate={translate}
                            {...StatusMessages[message.delivery_status]}
                            message={getMessage(message.delivery_status, retryEnabled, messageFailed, error)}
                        />
                    }
                </div>
            </div>
        }
        </div>
    );
};

export default MessageComponent;



// WEBPACK FOOTER //
// ./src/sections/Message/MessageComponent.tsx